var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F0F0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 40.75C43.25 42.1307 42.146 43.25 40.7842 43.25L23.2158 43.25C21.854 43.25 20.75 42.1307 20.75 40.75L20.75 37C20.75 35.6193 21.854 34.5 23.2158 34.5L40.7842 34.5C42.146 34.5 43.25 35.6193 43.25 37V40.75Z",
    stroke: "#6366F1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 23.25C43.25 21.8693 42.146 20.75 40.7842 20.75L23.2158 20.75C21.854 20.75 20.75 21.8693 20.75 23.25L20.75 27C20.75 28.3807 21.854 29.5 23.2158 29.5H40.7842C42.146 29.5 43.25 28.3807 43.25 27V23.25Z",
    stroke: "#6366F1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/Budget.1f33dcbccf058d82f9874c42b277c2d6.svg";
export { ForwardRef as ReactComponent };